/* eslint-disable max-len */
// import onCartUpdated from 'utils/cart';

// custom-element.js
export default class AddToCartForm extends HTMLElement {
  constructor() {
    super();
    this.form = null;
    this.productOptionSelectors = null;
    this.productGallery = null;
    this.productThumbnails = null;
  }

  connectedCallback() {
    this.productOptionSelectors = this.querySelectorAll(
      '[data-target="options"]',
    );

    this.form = this.querySelector('form');
    this.options = JSON.parse(decodeURIComponent(this.form.dataset.options));
    this.galleries = document.querySelectorAll('[data-image-group]');
    this.quantity = this.querySelector('#Quantity');
    this.incrementors = this.querySelectorAll('[data-incrementor]');
    this.sizeMessaging = this.querySelectorAll('[data-target="size-message"]');

    this.maxErrorWrapper = document.querySelector('[data-max-error]');
    this.maxErrorMessage = this.maxErrorWrapper?.innerText;

    this.badges = document.querySelectorAll('[data-badge-variant]');
    this.productGallery = document.querySelector(
      '[data-target="product-gallery-wrapper"]',
    );
    this.productThumbnails = document.querySelector(
      '[data-target="product-thumbnails"]',
    );

    this.cartUpsell = this.querySelector('[data-cart-upsell]');
    this.cartUpsellData = this.cartUpsell
      ? JSON.parse(this.cartUpsell.textContent)
      : null;

    this.init();
  }

  updateFitMessage() {
    const selectedVariant = this.getActiveVariant();

    if (selectedVariant) {
      const selectedVariantId = selectedVariant.id;

      const fitMessages = this.querySelectorAll('[data-fit-variant]');

      const activeMessages = this.querySelectorAll(
        `[data-fit-variant="${selectedVariantId}"]`,
      );

      fitMessages.forEach((message) => {
        message.classList.add('hidden');
      });

      activeMessages?.forEach((message) => {
        message.classList.remove('hidden');
      });
    }
  }

  updateSizeMessaging() {
    const selectedVariant = this.getActiveVariant();

    if (selectedVariant) {
      this.sizeMessaging.forEach((message) => {
        // eslint-disable-next-line no-param-reassign
        message.textContent = selectedVariant.size_messaging;
      });
    }
  }

  // This function disableds size options if color/size variant combo is OOS or Unavailable
  // comment out this.updateDisabledSizes() in script if implementing any BIS feature
  updateDisabledSizes() {
    const hasSizeOption = this.options.includes('Size');

    if (hasSizeOption) {
      const [sizeOptionIndex, colorOptionIndex] =
        this.options.indexOf('Size') === 0 ? [0, 1] : [1, 0];
      const sizeOption = `option${sizeOptionIndex + 1}`;
      const colorOption = `option${colorOptionIndex + 1}`;

      const variants = JSON.parse(
        decodeURIComponent(this.form.dataset.variants),
      );
      const colorInput = this.querySelector(
        'input[data-option-name="color"]:checked',
      );
      const color = colorInput ? colorInput.value : null;
      const sizes = this.querySelectorAll(`input[name="${sizeOption}"]`);

      sizes.forEach((size) => {
        size.removeAttribute('data-unavailable');
      });

      if (variants.length >= 1 && color) {
        const availableSizesLookup = {};
        variants.forEach((variant) => {
          if (variant[colorOption] === color) {
            availableSizesLookup[variant[sizeOption]] = true;
            if (!variant.available) {
              const targetSizeOption = this.querySelector(
                `input[value="${variant[sizeOption]}"]`,
              );
              targetSizeOption.setAttribute('data-unavailable', 'true');
            }
          }
        });

        sizes.forEach((size) => {
          if (!availableSizesLookup[size.value]) {
            size.setAttribute('data-unavailable', 'true');
          }
        });
      }
    }
  }

  // This function disableds color options if color/size variant combo is OOS or Unavailable
  updateDisabledColors() {
    const hasColorOption = this.options.includes('Color');

    if (hasColorOption) {
      const [sizeOptionIndex, colorOptionIndex] =
        this.options.indexOf('Size') === 0 ? [0, 1] : [1, 0];
      const sizeOption = `option${sizeOptionIndex + 1}`;
      const colorOption = `option${colorOptionIndex + 1}`;

      const variants = JSON.parse(
        decodeURIComponent(this.form.dataset.variants),
      );
      const sizeInput = this.querySelector(
        'input[data-option-name="size"]:checked',
      );

      const size = sizeInput ? sizeInput.value : null;
      const colors = this.querySelectorAll(`input[name="${colorOption}"]`);

      colors.forEach((color) => {
        color.parentNode
          .querySelector("[data-target='swatch-span']")
          .removeAttribute('data-unavailable-color');
      });

      if (variants.length >= 1 && size) {
        const availableColorsLookup = {};
        variants.forEach((variant) => {
          if (variant[sizeOption] === size) {
            availableColorsLookup[variant[colorOption]] = true;
            if (!variant.available) {
              const targetColorOption = this.querySelector(
                `input[value="${variant[colorOption]}"]`,
              ).parentNode.querySelector("[data-target='swatch-span']");
              targetColorOption.setAttribute('data-unavailable-color', 'true');
            }
          }
        });

        colors.forEach((color) => {
          if (!availableColorsLookup[color.value]) {
            color.parentNode
              .querySelector("[data-target='swatch-span']")
              .setAttribute('data-unavailable-color', 'true');
          }
        });
      }
    }
  }

  updateQuantityMax(availableQty) {
    this.quantity.max = availableQty;
    const quantityField = this.querySelector('#Quantity');
    const quantity = parseInt(quantityField.value, 10);
    const plusButton = document.querySelector('[data-incrementor="plus"]');
    const giftProduct = document.querySelector('[data-gift-product]');

    if (availableQty === 0 && !giftProduct) {
      this.querySelector('#add-to-cart-button').classList.add('disabled');
      this.maxErrorWrapper.classList.add('hidden');
      return;
    }

    if (!giftProduct) {
      if (parseInt(this.quantity.max, 10) <= quantity) {
        this.maxErrorWrapper.innerText = this.maxErrorMessage.replace(
          '{qty}',
          this.quantity.max,
        );
        this.maxErrorWrapper.classList.remove('hidden');
        quantityField.value = this.quantity.max;

        if (availableQty === parseInt(quantityField.value, 10)) {
          plusButton.classList.add('text-gray-700');
        }
      } else {
        plusButton.classList.remove('text-gray-700');
        this.maxErrorWrapper.classList.add('hidden');
      }

      if (availableQty < 1) {
        this.quantity.disabled = true;
        this.quantity.value = 1;
      } else {
        this.quantity.disabled = false;
      }
    } else {
      this.quantity.setAttribute('max', '');
    }
  }

  updateQuantity(event) {
    const incrementDirection = event.target.dataset.incrementor;
    const quantity = parseInt(this.querySelector('#Quantity').value, 10);
    const plusButton = document.querySelector('[data-incrementor="plus"]');
    const giftProduct = document.querySelector('[data-gift-product]');

    if (this.quantity.max < quantity && !giftProduct) return;

    if (!giftProduct) {
      if (
        incrementDirection === 'plus' &&
        parseInt(this.quantity.max, 10) <= quantity + 1
      ) {
        event.currentTarget.classList.add('text-gray-700');
        this.maxErrorWrapper.innerText = this.maxErrorMessage.replace(
          '{qty}',
          this.quantity.max,
        );
        this.maxErrorWrapper.classList.remove('hidden');
      } else {
        plusButton.classList.remove('text-gray-700');
        this.maxErrorWrapper.classList.add('hidden');
      }

      if (
        incrementDirection === 'plus' &&
        parseInt(this.quantity.max, 10) > quantity
      ) {
        this.quantity.value = quantity + 1;
      } else if (
        incrementDirection === 'minus' &&
        parseInt(this.quantity.min, 10) < quantity
      ) {
        this.quantity.value = quantity - 1;
      }
    } else if (incrementDirection === 'plus') {
      this.quantity.value = quantity + 1;
    } else if (
      incrementDirection === 'minus' &&
      parseInt(this.quantity.min, 10) < quantity
    ) {
      this.quantity.value = quantity - 1;
    }
  }

  updateQuantityInput(event) {
    const quantity = parseInt(this.quantity.value, 10);
    const plusButton = document.querySelector('[data-incrementor="plus"]');
    const incrementDirection = plusButton.dataset.incrementor;

    if (
      incrementDirection === 'plus' &&
      parseInt(this.quantity.max, 10) <= quantity
    ) {
      plusButton.classList.add('text-gray-700');
    } else {
      plusButton.classList.remove('text-gray-700');
    }

    if (
      parseInt(event.currentTarget.value, 10) > parseInt(this.quantity.max, 10)
    ) {
      this.quantity.value = this.quantity.max;
      this.maxErrorWrapper.innerText = this.maxErrorMessage.replace(
        '{qty}',
        this.quantity.max,
      );
      this.maxErrorWrapper.classList.remove('hidden');
    } else {
      this.maxErrorWrapper.classList.add('hidden');
    }
  }

  updateBadging() {
    const selectedVariant = this.getActiveVariant();
    const variantId = selectedVariant?.id;

    this.classList.remove('sale-product');

    this.badges.forEach((badge) => {
      badge.classList.add('hidden');
    });

    if (variantId !== null) {
      const targetBadges = document.querySelectorAll(
        `[data-badge-variant="${variantId}"]`,
      );

      targetBadges.forEach((badge) => {
        const badgeText = badge.textContent.toLowerCase();
        badge.classList.remove('hidden');

        if (badgeText.includes('sale') || badgeText.includes('clearance')) {
          this.classList.add('sale-product');
        }
      });
    }
  }

  onProductOptionChanged() {
    const selectedVariant = this.getActiveVariant();
    const availableQty = selectedVariant?.inventory_quantity || 0;

    this.updateBadging();
    this.updateQuantityMax(availableQty);
    this.updateFitMessage();
    this.updateSizeMessaging();
    this.updateDisabledSizes();
    this.updateDisabledColors();

    // Create a new custom event
    const customEvent = new CustomEvent('form:change', {
      bubbles: true,
      cancelable: true,
      detail: selectedVariant,
    });

    // Dispatch the custom event to the form element
    this.form.dispatchEvent(customEvent);

    this.productGallery?.dispatchEvent(customEvent);
    this.productThumbnails?.dispatchEvent(customEvent);
  }

  getActiveVariant() {
    const variants = JSON.parse(decodeURIComponent(this.form.dataset.variants));

    const formData = this.serializeForm();
    const formOptions = {
      option1: null,
      option2: null,
      option3: null,
    };
    let selectedVariant = null;

    formData.forEach((item) => {
      if (item.name.indexOf('option') !== -1) {
        formOptions[item.name] = item.value;
      }
    });

    variants.forEach((variant) => {
      if (
        variant.option1 === formOptions.option1 &&
        variant.option2 === formOptions.option2 &&
        variant.option3 === formOptions.option3
      ) {
        selectedVariant = variant;
      }
    });

    return selectedVariant;
  }

  serializeForm() {
    const formData = new FormData(this.form);
    const serializedArray = [];

    for (const [name, value] of formData.entries()) {
      serializedArray.push({ name, value });
    }

    return serializedArray;
  }

  validate(event) {
    const hasVariant = event?.detail !== null;
    const canAddToCart = hasVariant && event?.detail?.available === true;
    const inputId = this.querySelector('[data-target="variant-id"]');
    const addToCartButton = this.querySelector('#add-to-cart-button');
    const price = this.querySelector('[data-target="product-price"]');
    const lpropText = this.querySelectorAll('[data-target="lprop-text"]');
    const ctaCopy = this.querySelectorAll('[data-target="cta-message"]');
    const upSell = this.querySelector('[data-target="simple-upsell"]');
    let formattedVariantPrice;
    let comparePrice;
    let priceHtml;

    if (event?.detail?.available) {
      upSell.style.display = 'block';
    } else {
      upSell.style.display = 'none';
    }

    if (hasVariant) {
      formattedVariantPrice = `$${(event.detail.price / 100).toFixed(2)}`;
      comparePrice = `$${(event.detail.compare_at_price / 100).toFixed(0)}`;

      priceHtml = `
      <span class="font-bold sale-product:text-accentColor-1">
      ${formattedVariantPrice} 
      <span
        data-target='compare-price'
        class='body-2 sale-product:text-default text-gray-800 single-image:hidden'
      >
      |
      <span class='body-2 text-gray-800'>${comparePrice}</span>
      <span class='body-2 text-gray-800'>
        Comp. Value</span>
    </span>`;

      if (window.location.pathname.includes('/products/')) {
        window.history.replaceState(
          null,
          null,
          `?variant=${event?.detail?.id}`,
        );
      }
    } else {
      priceHtml = price.dataset.defaultPrice;
    }

    // eslint-disable-next-line no-return-assign, no-param-reassign
    lpropText.forEach((item) => (item.innerText = event.detail?.lprop));

    ctaCopy.forEach((item) => {
      switch (event.detail?.lprop?.toLowerCase()) {
        case 'final sale':
          // eslint-disable-next-line no-param-reassign
          item.innerText = item.dataset.sale;
          break;
        case 'exchange only':
          // eslint-disable-next-line no-param-reassign
          item.innerText = item.dataset.exchange;
          break;
        default:
          // eslint-disable-next-line no-param-reassign
          item.innerText = item.dataset.shipping;
      }
    });

    if (canAddToCart) {
      inputId.value = event?.detail?.id;
      addToCartButton.classList.remove('disabled');
    } else {
      inputId.value = '';
    }

    if (event?.detail?.available === false) {
      addToCartButton.textContent = window.TMW.Strings.product.outOfStock;
    } else if (event?.detail === null) {
      addToCartButton.textContent = window.TMW.Strings.product.unavailable;
    } else {
      addToCartButton.innerHTML = `${window.TMW.Strings.product.addToCart} <span class="font-bold hidden atc-sticky:block lg:atc-sticky:hidden" data-target="product-price" data-default-price="${formattedVariantPrice}">
      &nbsp; — &nbsp;${formattedVariantPrice}</span>`;
    }

    price.innerHTML = priceHtml;
  }

  onAddToCart(event) {
    event.preventDefault();
    const activeVariant = this.getActiveVariant();
    const canAddToCart = activeVariant.available;
    const inventoryQuantity = activeVariant.inventory_quantity;

    if (!canAddToCart) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      return;
    }

    const formData = new FormData(this.form);

    const checkboxValue = formData.get('variantCheckbox');

    const originalProductId = formData.get('id');
    const originalProductQuantity = formData.get('quantity');

    const attributes = [
      {
        key: '_inventory_quantity',
        value: inventoryQuantity,
      },
    ];

    if (activeVariant.lprop) {
      attributes.push({
        key: '_lprop',
        value: activeVariant.lprop,
      });
    }

    let payload = {
      merchandiseId: `${originalProductId}`,
      quantity: originalProductQuantity,
      attributes,
    };

    if (checkboxValue) {
      const additionalProductId = checkboxValue;
      const target = this.querySelector('#variantCheckbox');
      const simpleUpsellInventory = target.dataset.inventory;
      const simpleUpsellLprop = target.dataset.lprop;

      const simpleUpsellAttributes = [
        {
          key: '_inventory_quantity',
          value: simpleUpsellInventory,
        },
      ];

      if (simpleUpsellLprop) {
        simpleUpsellAttributes.push({
          key: '_lprop',
          value: simpleUpsellLprop,
        });
      }

      payload = [
        {
          merchandiseId: `${originalProductId}`,
          quantity: originalProductQuantity,
          attributes,
        },
        {
          merchandiseId: `${additionalProductId}`,
          quantity: 1,
          attributes: simpleUpsellAttributes,
        },
      ];
    }

    // Used for liquid minicart
    // if (checkboxValue) {
    //   const additionalProductId = checkboxValue;
    //   const additionalProductQuantity = '1';

    //   formData.delete('id');
    //   formData.delete('quantity');
    //   formData.append('id[]', originalProductId);
    //   formData.append('quantity[]', originalProductQuantity);
    //   formData.append('id[]', additionalProductId);
    //   formData.append('quantity[]', additionalProductQuantity);
    // }

    localStorage.setItem(
      'upsellProductData',
      JSON.stringify(this.cartUpsellData.cartUpsell),
    );

    const addToCartEvent = new CustomEvent('cart:add', {
      detail: {
        payload,
      },
    });
    document.dispatchEvent(addToCartEvent);

    // Used for liquid minicart
    // fetch('/cart/add.js', {
    //   method: 'POST',
    //   body: formData,
    //   headers: {
    //     Accept: 'application/json',
    //   },
    // })
    //   .then((response) => response.json())
    //   .then((data) => {
    //     console.log(data);
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //   });
  }

  init() {
    this.updateBadging();
    this.updateFitMessage();
    this.updateDisabledSizes();
    // this.updateDisabledColors();

    this.incrementors.forEach((item) => {
      item.addEventListener('click', (event) => {
        this.updateQuantity(event);
      });
    });

    this.quantity.addEventListener('input', (event) =>
      this.updateQuantityInput(event),
    );

    this.quantity.addEventListener('change', (event) => {
      // eslint-disable-next-line no-param-reassign
      if (!event.currentTarget.value) event.currentTarget.value = 1;
    });

    this.productOptionSelectors.forEach((item) => {
      item.addEventListener('change', (event) => {
        this.onProductOptionChanged(event);
      });
    });

    this.form.addEventListener('form:change', (event) => {
      this.validate(event);
    });

    this.form.addEventListener('load', (event) => {
      this.validate(event);
    });

    this.form.addEventListener('submit', (event) => {
      this.onAddToCart(event);
    });
  }
}
